import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  alpha,
} from '@mui/material';
import BaseTab from './BaseTab';

interface BackendOverviewTabProps {
  isDark: boolean;
  colors: any;
  discordFont: any;
  glassStyle: any;
  lokiGradient: string;
  goldColor: string;
  isMobile: boolean;
}

const BackendOverviewTab: React.FC<BackendOverviewTabProps> = (props) => {
  return (
    <BaseTab
      {...props}
      title="Backend Overview"
      emoji="🚀"
    >
      <Typography variant="body1" color={props.colors.textPrimary} sx={{ mb: 2 }}>
        A comprehensive backend API for WFHCafe, a social platform that connects cafe enthusiasts through communities, posts, real-time chat, and cafe discovery features.
      </Typography>
      
      <Paper sx={{ bgcolor: alpha(props.goldColor, 0.1), p: 2, borderRadius: 2, mb: 3 }}>
        <Typography variant="h6" sx={{ color: props.goldColor, mb: 1 }}>
          Core Functionality
        </Typography>
        <Grid container spacing={2}>
          {[
            { icon: '👥', title: 'User Authentication', desc: 'Local + Google OAuth' },
            { icon: '🏘️', title: 'Community Management', desc: 'Create, join, manage' },
            { icon: '💬', title: 'Social Posts', desc: 'Text, image, video' },
            { icon: '⚡', title: 'Real-time Chat', desc: 'WebSocket based' },
            { icon: '☕', title: 'Cafe Discovery', desc: 'Google Maps integration' },
            { icon: '🛡️', title: 'Reporting System', desc: 'Admin moderation' },
          ].map((feature, idx) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={idx}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <Typography variant="h5">{feature.icon}</Typography>
                <Box>
                  <Typography variant="subtitle2" fontWeight={700} color={props.colors.textPrimary}>
                    {feature.title}
                  </Typography>
                  <Typography variant="caption" color={props.colors.textSecondary}>
                    {feature.desc}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </BaseTab>
  );
};

export default BackendOverviewTab;